import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-bold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-[#FF6B9D] text-black border-2 border-black hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[4px_4px_0_#1A1A1A] active:translate-x-1 active:translate-y-1 active:shadow-none hover:bg-[#FF80AB]",
        destructive:
          "bg-status-error text-white border-2 border-black hover:bg-status-error/90 hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[4px_4px_0_#1A1A1A]",
        outline:
          "border-2 border-foreground bg-background hover:bg-foreground hover:text-background",
        secondary:
          "bg-secondary text-secondary-foreground border-2 border-foreground hover:bg-secondary-hover",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-lg px-3",
        lg: "h-11 rounded-xl px-8",
        icon: "h-10 w-10 rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
